import { Switch } from '@mui/material';
import { rgb } from '@design-system/tokens';
import * as styles from './ToggleRow.css';

type ToggleRowProps = {
  label: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  ariaLabel: string;
  disabled?: boolean;
  testId?: string;
};

export const ToggleRow = ({
  label,
  checked,
  onChange,
  ariaLabel,
  disabled,
  testId,
}: ToggleRowProps) => (
  <div className={styles.row}>
    <span className={styles.label}>{label}</span>
    <Switch
      checked={checked}
      onChange={(_, next) => onChange(next)}
      disabled={disabled}
      inputProps={{
        'aria-label': ariaLabel,
        ...(testId ? { 'data-testid': testId } : {}),
      }}
      sx={{
        '& .MuiSwitch-switchBase.Mui-checked': { color: rgb('W-100') },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: rgb('P-80'),
          opacity: 1,
        },
      }}
    />
  </div>
);
